<template>
<div style="margin:5px;">
      <br>
          <Row><Col span="12" offset="10"><div class="myTitle" >经营单位列表</div></Col></Row>
        <br>
        <Row>
                <div class="queryForm">
                    <Form ref="queryFormRef" :model="queryForm" :label-width="80" inline>
                         <FormItem label="单位名称" prop="companyName" >
                            <Input v-model="queryForm.companyName" placeholder="单位名称" style="width:250px"></Input>
                        </FormItem>
                        <FormItem label="类别" prop="category">
                            <Select  v-model="queryForm.category"  :clearable="true"  :transfer="true">
                                    <Option value="演出">演出</Option>
                                    <Option value="文化">文化</Option>
                                    <Option value="旅游">旅游</Option>
                                    <Option value="票务">票务</Option>
                                </Select>
                        </FormItem>
                        <Button type="info"  @click="queryBtn" >查询</Button>
	                    <Button type="success"  @click="resetQueryForm">重置</Button>
                    </form>
                </div>
            </Row>
             <br>
      <Row >
          <Col span="20" offset="1">
            <div style="float:left">
               <Button type="info"  @click="openAddForm()">新增</Button>&nbsp;&nbsp;&nbsp;
               <Button type="success"   @click="openExport()">导出</Button>&nbsp;&nbsp;&nbsp;
               <Upload   
                  :action="uploadUrl"
                  name="file" 
                  :on-success="handleSuccess" 
                  :before-upload="handleBeforeUpload"
                   :headers = "headers"
                  multiple = "multiple"
                  :show-upload-list="showUploadList"
             >
                    <Button type="success" >导入</Button>
                </Upload>&nbsp;
               <a href="https://patrol.stwhgl.com/stat_report/经营单位库批量导入-参考模板.xlsx" target="_blank">导入模板下载</a>
               
            </div>
          </Col>
      </Row>
      <br>
        
      <Row>
          <Col span="24">
              <Table :loading="loading" @on-selection-change="selectRow" 
                border ref="table" stripe :columns="columns4" :data="listData">
                <template slot-scope="{ row }" slot="name">
                  <strong>{{ row.name }}</strong>
                </template>
                <template slot-scope="{ row }" slot="action">
               
                  <Button type="info" size="small" @click="openUpdateForm(row)">修改</Button>
                  <Button type="error" size="small" @click="deleleRows(row)">删除</Button>
                </template>
              </Table>
          </Col>
      </Row>
      <Row>
        <Col span="24">
          <div>
            <Footer>
              <Page show-sizer show-total :total="rowCount" :current="current"
                :page-size="pageSize"  @on-change="changePage"
                @on-page-size-change="changeSize" />
            </Footer>
          </div>
        </Col>
    </Row>
  <CompanyEdit ref="companyEdit"></CompanyEdit>
 
</div>
</template>

<script>

  import CompanyEdit from '@/pages/platform/company/CompanyEdit';
  import  downloadTemplate   from "@/utils/downloadFile";
  import {getCookie} from '@/utils/cookieUtils'

  export default {
    components: {
        CompanyEdit
    },
    methods: {
    
      selectRow(selection) {
        this.selectRows = selection;
      },
      //打开新增对话框
      openAddForm() {
        this.$refs.companyEdit.openModal('新增',null);
      },
      //打开修改对话框
      openUpdateForm(row) {
       this.$refs.companyEdit.openModal('修改',row);
       
      },
       
          //导出
      openExport(){
            let url = `/api/unit/export_data`
                      this.req({
                         url: url,
                          method: 'post',
				                	responseType: "arraybuffer",
                          data: {
                              companyName:this.queryForm.companyName,
                              category:this.queryForm.category,
                          }
                      }).then(response => {
                          downloadTemplate.fileDownload(response.data, "company.xlsx");
                     }).catch(error => {
                          this.$Message.error('服务器错误:' + error)
                     })
      },
    
       //执行删除操作
            deleleRows(row) {
               
                this.$Modal.confirm({
                    title: '删除',
                      content: `确认要删除\"${row.companyName}\"吗?`,
                    onOk: () => {
                         this.loading = true
                         let url = `/api/unit`
                            this.req({
                                url: url,
                                method: 'delete',
                                data: {
                                    _id: row._id
                                }
                            }).then(response => {
                                this.$Message.success(
                                {
                                    content:response.data.msg,
                                    top: 80,
                                    onClose: ()=>{
                                        this.loading = false
                                        this.loadPage();
                                    }
                                }
                                )
                        }).catch(error => {
                                this.$Message.error('服务器错误:' + error)
                        })
                    },
                    onCancel: () => {
                       // this.loading = false
                    }
                });

            },
        //上传文件成功
       handleSuccess(res, file) {
          this.$Message.success(
                  {
                      content:res.msg,
                      top: 80,
                      onClose: ()=>{
                          this.loading = false
                          this.loadPage();
                      }
                  }
                  )
      },
      handleBeforeUpload(){
          return true;
      },
      loadPage() {
         this.loading = false
        let url   = `api/unit`
        this.req({
          url: url,
          method: 'post',
          data:{
            p: this.current,
            pageSize: this.pageSize,
            companyName:this.queryForm.companyName,
            category:this.queryForm.category,
            type: 2
          }
        }).then(resp => {
          this.buildPageData(resp.data.page)
          this.loading = false
        }).catch(error => {
          this.$Message.error('服务器错误2:' + error);
        })
      },
      changePage(curPage) {
        this.loading = true
        this.current = curPage
        this.loadPage()
      },

      changeSize(pageSize) {
        this.pageSize = pageSize
        this.loading = true
        this.loadPage()
      },
      buildPageData(dataObj) {
        this.listData = dataObj.list;
        this.pageSize = dataObj.size;
        this.rowCount = dataObj.rowCount;
        this.currentPage = dataObj.p;
      },
      resetQueryForm() {
        this.$refs["queryFormRef"].fields.forEach(function (e) {
           e.resetField()
        })
      },
      queryBtn(){
                this.current = 1
                this.loadPage()
      },
   
     
     
    },
    mounted: function () {
      let compay =this.$route.query.compay
			this.queryForm.companyName=compay
      this.loadPage();
       this.loading = false
        this.uploadUrl =  window.g.ApiUrl + "api/unit/add_many_data"
    },
    data() {
      return {
        listData: [],
        pageSize: 10,
        current: 1,
        rowCount: 0,
        loading: true,
        deleteId: '',
        showcity: true,
        showcountry: true,
        uploadUrl:'',  
        showUploadList: false,   
       headers: {
            token: getCookie('wcToken') 
        },  
        columns4: [{
            type: 'index',
            title:'序号',
            width: 60,
            align: 'center',
          },
          {
            title: '单位名称',
            align: 'center',
            key: 'companyName',
          },
          {
            title: '类别',
            align: 'center',
            width: 80,
            key: 'category'
          },
           {
            title: '注册地址',
            align: 'center',
            key: 'companyAddress'
          },{
            title: '法人',
            align: 'center',
            width: 100,
            key: 'companyCorp'
          },{
            title: '联系电话',
            align: 'center',
            width: 130,
            key: 'tel1',
             render:(h,params)=>{
                              let text='';
                            if(params.row.tel1!=undefined){
                               text+=params.row.tel1
                            }
                            if(params.row.phone!=undefined){
                              if(text!=''){
                                text+="/"
                              }
                              text+=params.row.phone
                            }
                             
                             return h("div",{domProps:{
                                innerHTML:`<div >`+text+`</div>`
                            }})
                         }

          },
           {
            title: '网站地址',
            align: 'center',
            width:130,
            key: 'companyUrl'
          },
          {
            title: '操作',
            slot: 'action',
            width: 130,
            align: 'center'
          }
        ],
       //查询表单的初始值
          queryForm: {
              companyName: '',
              category:'',
          }
      }
    },

  }
</script>

<style scoped>
  .ivu-layout-header {
    background: #f5f7f9;
  }

 

  .queryForm {
    padding: 10px;
  }
  .queryBtn {
    padding-bottom: 5px;
    padding-left: 700px;
    border-bottom: rgb(160, 146, 146) solid 1px;
  }
  .optBtn {
    margin: 10px;
  }
  .ivu-form-item {
    margin-bottom: 0px;
  }
  .a {
    color: #fff;
  }
   .myTitle{
      font-size: 20px;
      font-weight: 700;
  }
    .ivu-upload{
    display: inline-block;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/company/CompanyList.vue